import * as React from "react";
import { useDispatch } from "react-redux";
import { Header, HeaderPrimary, HeaderSecondary } from "@emisgroup/ui-sections";
import { Button } from "../Common/UI/Index";
import { APP_FEASIBILITY } from "../AppConfig/Constant";
import { AppConfigSlice } from "../AppConfig/Redux/Index";
import { FeasibilityAppLogo } from "./FeasibilityAppLogo";
import { BannerActions } from "./BannerActions";
import { CountDownTimer } from "./CountDownTimer";
import "./Style.scss";

/**
 * To render the App banner component
 * @returns the banner component
 */
export const AppBanner: React.FC = ()=> {

  const dispatch = useDispatch();

  React.useEffect(() => {
    // Setting Feasibility app
    sessionStorage.setItem("appKey", APP_FEASIBILITY);
    dispatch(AppConfigSlice.actions.setAplicationKey(APP_FEASIBILITY));
  }, []);

  return (
    <div className="ebt-topbar">
      <Header
        className="branding-banner"
      >
        <HeaderPrimary>
          <Button borderless={true} className="logo-btn">
            <FeasibilityAppLogo />
          </Button>
        </HeaderPrimary>
        <HeaderSecondary>
          <CountDownTimer />
          <BannerActions />
        </HeaderSecondary>
      </Header>
    </div>
  );
};
